import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useToast } from '@shared/hooks/use-toast';
import { useState, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { WithdrawalPaymentFilesApiAdapter } from '../adapters';

export const useDownloadWithdrawalPaymentFile = () => {
  const [downloadingFileId, setDownloadingFileId] = useState<number | null>(null);
  const { toast } = useToast();
  const { t } = useTranslation('withdrawalPaymentFilesModule');
  const apiAdapter = useMemo(() => new WithdrawalPaymentFilesApiAdapter(createHttpClient(apiClientWH)), []);

  const downloadFile = async (fileId: number) => {
    setDownloadingFileId(fileId);
    try {
      console.log('🔍 useDownloadWithdrawalPaymentFile - Downloading:', { fileId });

      const result = await apiAdapter.downloadPaymentFile(fileId);

      if ('url' in result) {
        // Redirect a la URL que devuelve la API (descarga gestionada externamente)
        window.location.href = result.url;
      } else {
        const { blob, filename } = result;

        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      }

      toast({
        title: t('download.success.title'),
        description: t('download.success.description'),
        variant: 'default',
      });
    } catch (error: any) {
      console.log('🔍 useDownloadWithdrawalPaymentFile - Error:', { message: error.message, response: error.response });
      toast({
        title: t('download.error.title'),
        description: error.message || t('download.error.unexpected'),
        variant: 'destructive',
      });
    } finally {
      setDownloadingFileId(null);
    }
  };

  return {
    downloadFile,
    downloadingFileId,
    isDownloading: downloadingFileId !== null,
  };
};
